import {SignerTransaction, SwapQuote, V2SwapExecution} from "@tinymanorg/tinyman-js-sdk";

import {SimpleAsset} from "../../asset/util/assetModels";

export interface SwapFormQueryParams {
  asset_in?: null | number | string;
  asset_out?: null | number | string;
}

export enum SwapFormTextFieldNames {
  AssetInAmount = "asset-in-amount",
  AssetOutAmount = "asset-out-amount"
}

export type SwapFormState = {
  isReady: boolean;
  assetIn: {
    asset: SimpleAsset | null;
    [SwapFormTextFieldNames.AssetInAmount]: string;
  };
  assetOut: {
    asset: SimpleAsset | null;
    [SwapFormTextFieldNames.AssetOutAmount]: string;
  };
  quote: null | SwapQuote;
  txnsToSign: null | SignerTransaction[];
};

export type SwapFormStateContextValue = SwapFormState;
export type SwapFormDispatchContextValue =
  null | React.Dispatch<SwapFormStateReducerAction>;

export type SwapFormStateReducerAction =
  | {type: "SET_IS_READY"; isReady: boolean}
  | {
      type: "SET_AMOUNT";
      name: SwapFormTextFieldNames;
      value: string;
    }
  | {
      type: "SET_SWAP_FORM_ASSETS";
      assetIn: SwapFormState["assetIn"]["asset"];
      assetOut: SwapFormState["assetIn"]["asset"];
    }
  | {
      type: "SET_QUOTE";
      quote: SwapQuote | null;
    }
  | {
      type: "RESET_FORM";
      isReady?: boolean;
    }
  | {
      type: "FLIP_ASSET_ORDER";
    }
  | {
      type: "SET_TRANSACTIONS_TO_SIGN";
      txnsToSign: SignerTransaction[];
    };

export interface SwapImpact {
  maximumSent: number;
  minimumReceived: number;
  slippage: string;
  totalFee: bigint;
  priceImpact: number;
}

export type SwapExecution = V2SwapExecution;

export interface SwapFundSufficiencyInformation {
  assetInBalance: {
    hasEnough: boolean;
    message: string /* <- this string would be `You don’t have enough balance. You need to have at least ${minimumAssetInBalanceToSwap} ${assetIn?.unit_name} to carry out this swap.` Message would be empty string if assetIn was ALGO. */;
  };
  algoBalance: {
    hasEnough: boolean;
    message: string /* <- this string would be `You don’t have enough balance. You need to have at least ${minimumAlgoBalanceToSwap} ALGO to carry out this swap.` */;
  };
}
